import { handleActions } from 'redux-actions';
import * as R from 'ramda';

import {
  FETCH_ACCOUNT_GROUPS,
  FETCH_ACCOUNT_GROUP,
  UPDATE_ACCOUNT_GROUP,
  CREATE_ACCOUNT_GROUP,
  RESET_CURRENT_GROUP
} from '../../constants/Constants';

const initialState = { items: [], filter: null, currentGroup: {} };

const COLLATOR = new Intl.Collator('cs');
const nameComparator = (a, b) => COLLATOR.compare(a.name, b.name);

export default handleActions(
  {
    [FETCH_ACCOUNT_GROUPS.SUCCESS]: (state, { payload: { items } }) => ({
      ...state,
      items: R.sortWith([nameComparator])(items)
    }),
    [FETCH_ACCOUNT_GROUP.SUCCESS]: (state, { payload: { payload } }) => ({ ...state, currentGroup: payload }),
    [UPDATE_ACCOUNT_GROUP.SUCCESS]: (state, { payload: { payload } }) => ({
      ...state,
      currentGroup: payload,
      currentGroupSaving: false,
      currentGroupError: null
    }),
    [CREATE_ACCOUNT_GROUP.ERROR]: (state, { payload }) => ({ ...state, currentGroupError: payload }),
    [UPDATE_ACCOUNT_GROUP.ERROR]: (state, { payload }) => ({ ...state, currentGroupError: payload }),
    [CREATE_ACCOUNT_GROUP.PENDING]: state => ({ ...state, currentGroupSaving: true }),
    [UPDATE_ACCOUNT_GROUP.PENDING]: state => ({ ...state, currentGroupSaving: true }),
    [RESET_CURRENT_GROUP]: state => ({ ...state, currentGroup: null, currentGroupSaving: false })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/entities/AccountGroupsReducer.js